module.exports = __webpack_public_path__ + "static/media/ai-power-recommend-addon.9de5b9d9.png";